import { FC } from 'react';

import styles from './business-hub-footnotes.module.scss';

interface Props {
    content?: string;
}

const BusinessHubFootnotes: FC<Props> = (props) => {
    const { content } = props;

    if (!content) return null;

    return <div className={styles.container} dangerouslySetInnerHTML={{ __html: content || '' }} />;
};

export default BusinessHubFootnotes;
